<script>
    import {push,location} from 'svelte-spa-router';
    let togle = false;
    let urls = [
        {titulo: 'Inicio', href:'/'},
        {titulo: 'Sobre Nosotros', href:'/sobre-nosotros'},
        {titulo: 'Nuestros Modelos', href:'/tienda'},
        {titulo: 'FAQ', href:'/faq'},
        {titulo: 'Contacto', href:'/contacto'},
    ];
    function cambiar(){
        togle = !togle;
    }
    function goTo(url){
        push(url);
        togle = false;
    }
</script>

<div class={(!togle? "menuBoton cerrado" : "menuBoton abierto")} on:click={cambiar}>
    <span></span>
    <span></span>
    <span></span>
</div>
<div class="menuContenedor">
    <div class={(!togle? "movible cerrado" : "movible abierto")}>
        {#each urls as item}
            {#if item.href != $location}
                <div class='item' on:click={()=>{goTo(item.href);}}>{item.titulo}</div>
            {/if}
        {/each}
    </div>
</div>

<style>
    .menuBoton{
        position: absolute;
        top: calc(20vh + 10px);
        left: calc(10vw + 10px);
        width: 50px;
        height: 50px;
        z-index: 100;
        cursor: pointer;
    }
    .menuBoton > span{
        content: "";
        width: 25px;
        height: 5px;
        position: absolute;
        top: 25px;
        left: 12.5px;
        border-radius: 2.5px;
        background: white;
        transition: all .4s ease;
    }
    .menuBoton > span:nth-child(1){
        top: 35px; 
    }
    .menuBoton > span:nth-child(2){
        top: 45px;
    }
    .menuBoton.abierto > span{
        transform: rotate(155deg);
        top: 30px;
    }
    .menuBoton.abierto > span:nth-child(1){ 
        opacity: 0;
    }
    .menuBoton.abierto > span:nth-child(2){
        top: 40px;
        transform: rotate(-155deg);
    }

    .menuContenedor{
        position: absolute;
        top: calc(20vh + 6px);
        left: calc(10vw);
        width: 200px;
        height: 60vh;
        z-index: 50;
        overflow: hidden;
    }
    .movible{
        position: absolute;
        top: 0;
        left: 0;
        width: 200px;
        height: 60vh;
        background:var(--principal);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition: all .6s ease;
    }
    .movible.cerrado{
        left: -200px;
    }
    .movible > .item{
        color: white;
    }
    .movible > .item:hover{
        font-weight: bold;
        color: white;
        cursor: pointer;
    }
</style>